export async function generateSeededRandomNumber(
  seed: string,
  min: number,
  max: number
): Promise<number> {
  const encoder = new TextEncoder();
  const data = encoder.encode(seed);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
  const num = parseInt(hashHex.slice(0, 8), 16);
  return min + (num % (max - min + 1));
}
